import ABCookieManager from '../lib/ab_cookie_manager'
import AbPubSub from '../lib/ab_pubsub'
import AbstractSearch from '../../../widgets/form/abstract_search/script'
import AccountActivationWidget from '../../../widgets/modal/account_activation/script'
import AdminBar from '../../../widgets/admin_bar/script'
import Autocomplete from '../lib/autocomplete'
import EmailUpdateWidget from '../../../widgets/modal/email_update/script'
import FlashMessagesWidget from '../../../widgets/flash_messages/script'
import FormattedInput from '../lib/formatted_input'
import FormattedPhoneNumberInput from '../lib/formatted_phone_number_input'
import GlobalWindowEventManager from '../lib/global_window_event_manager'
import LazyLoader from '../lib/lazy_loader'
import MarketingOverlayBoxWidget from '../../../widgets/marketing_overlay_box/script'
import MirrorSearch from '../lib/mirrorsearch'
import ModalLoginWidget from '../../../widgets/modal/login/script'
import ModalRegisterWidget from '../../../widgets/modal/register/script'
import ModalWidget from '../../../widgets/modal/main/script'
import MoveToTopButton from '../../../widgets/move_to_top_button/script'
import NavigationManager from '../lib/navigation_manager'
import NavigationSearchBar from '../../../widgets/navigation/main/search_bar/script'
import NavigationWidget from '../../../widgets/navigation/main/script'
import PasswordFieldWidget from '../../../widgets/password_field/script'
import PasswordFieldWithValidationWidget from '../../../widgets/password_field_with_validation/script'
import RemoveErrors from '../lib/remove_errors'
import ScrollTo from '../lib/scrollto'

export default class Page {
  constructor() {
    this.pubSub = AbPubSub.getInstance()
    this.cookie = ABCookieManager.getInstance()
    new GlobalWindowEventManager(this.pubSub)

    // we should initialize widgets and other scripts, that are used almost everywhere here\
    new AbstractSearch()
    new AccountActivationWidget()
    new AdminBar()
    new Autocomplete()
    new EmailUpdateWidget()
    new FlashMessagesWidget()
    new FormattedInput(this.pubSub)
    new FormattedPhoneNumberInput()
    new LazyLoader()
    new MarketingOverlayBoxWidget()
    new MirrorSearch()
    new ModalLoginWidget()
    new ModalRegisterWidget()
    new ModalWidget()
    new MoveToTopButton()
    new NavigationManager()
    new NavigationSearchBar()
    new NavigationWidget()
    new PasswordFieldWidget()
    new PasswordFieldWithValidationWidget()
    new RemoveErrors()
    new ScrollTo()
    this.disabled_gtm_count()
  }

  disabled_gtm_count() {
    window.addEventListener(
      'load',
      () => {
        if (!window.google_tag_manager) {
          $.ajax({
            type: 'POST',
            url: '/ajax/increment_disabled_gtm_count'
          })
        }
      },
      false
    )
  }
}
